import { CaptivateIQEvents } from '@captivateiq/events';
import { EVENT } from 'constants/events';

// combines shared code with local event constants
export class Events extends CaptivateIQEvents {
  static EVENT = EVENT;
}
